const productColours = [
    '#1F65AB', '#F8A92A', '#A3367C', '#009664', '#6B1462', '#0159D3','#1F65AB', '#F8A92A', '#A3367C', '#009664', '#6B1462', '#0159D3','#1F65AB', '#F8A92A', '#A3367C', '#009664', '#6B1462', '#0159D3','#1F65AB', '#F8A92A', '#A3367C', '#009664', '#6B1462', '#0159D3'   
];
    
export default productColours;
